import { Injectable } from '@angular/core';
import { isEmpty } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CheckerUtil {

  constructor(

  ) { }

  isValidText( text: string )
  {
    return text && text.trim().length > 0
  }

  isValidLatitude(latitude: number)
  {
    return latitude && (latitude < 90 && latitude > -90)
  }

  isValidLongitude(longitude: number)
  {
    return longitude && (longitude < 180 && longitude > -180)
  }

  hasMinLength( text: string , m: number )
  {
    return this.isValidText(text) && text.length >= m
  }

  hasMaxLength( text: string , M: number)
  {
    return this.isValidText(text) && text.length <= M
  }

  isValidId( id: number )
  {
    return id && id > 0
  }

  isValidDow( dow: number )
  {
    if( dow && (dow > 0 && dow <= 7)) return true
    return false
  }

  isEquals( text: string, text1: string )
  {
    return text === text1
  }

  isOperationDone( response: any )
  {
    return response.result === 1
  }

  isValidPhoneNumber( text: string )
  {
    const regex = /^\+?[0-9][0-9]{6,14}$/
    return text && regex.test( text )
  }

  isValidEmail( text: string )
  {
    const regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return text && regex.test( text )
  }

}
